module.exports = __webpack_public_path__ + "static/shopping-assistant-c09067e5a42969fd61917bb5dd48bc0b.png";